export const allMeetings = "/host/allmeetings";
export const showMeeting = "/host/allmeetings/showmeeting";
